import { FormikHelpers } from "formik";
import { useCreateProvider } from "./api/createProvider";
import ProviderForm from "./ProviderForm";


const CreateProvider = ({handleCloseModal}: CreateProviderProps)  => {
  const createProviderMutation = useCreateProvider({data: {}});

  const initialValues: IPostNewProvider = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewProvider, { setSubmitting }: FormikHelpers<IPostNewProvider>): Promise<void> => {
    try {
      await createProviderMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <ProviderForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateProviderProps {
  handleCloseModal: () => void;
}

export default CreateProvider;